<div class="overview-item">
  <div class="d-flex align-items-center">
    <div class="w-100">
      <div class="title">{{ 'INVOICE.TOTAL_AMOUNT' | translate }}</div>
      <app-money-box class="amount" [dataContext]="amount"></app-money-box>
      @if (showRounding) {
        <div class="rounding">
          ({{ 'INVOICE.PREVIEW.ROUNDING' | translate }}: {{ roundingSign }}<app-money-box [dataContext]="rounding"></app-money-box>)
        </div>
      }
    </div>
  </div>
</div>
